import { Box, Typography } from '@mui/material'
import { Image, ImageData, type VideoData } from '@media-components'
import {
  SimpleDocumentRenderer,
  SimpleDocumentRendererData,
} from '@components/common/DocumentRenderer'
import { ActionButton, ActionButtonData } from '../../ActionButton'
import { Chip, ChipData } from '../../Chip'
import { IconData, IconImage } from '../../IconImage'

export type CardData = {
  type?: string
  iconData?: IconData
  imageData?: ImageData
  title: string
  description?: string
  position?: number
  documentData?: SimpleDocumentRendererData
  actionButtonData?: ActionButtonData
  chipsData?: ChipData[]
  points?: string[]
  statsData?: {
    label: string
    description: string
  }[]
  imageLink?: string
  href?: string
  videoData?: VideoData
  productCategoryData?: {
    id: string
    label: string
    description?: string
    iconData?: IconData
  }
}

type CardProps = CardData

export function DefaultCard({
  iconData,
  chipsData,
  title,
  description,
  actionButtonData,
  imageData,
  points,
  documentData,
}: CardProps) {
  return (
    <Box>
      {iconData && <IconImage {...iconData} />}
      {!!chipsData?.length && (
        <Box>
          {chipsData.map((item, idx) => (
            <Chip
              key={idx}
              {...item}
              csx={{
                wrapper: {
                  color: 'text.primaryDark',
                  backgroundColor: '#FFFFFF0D',
                  backdropFilter: 'blur(20px)',
                  boxShadow: '0px 4px 15px 0px #00000026',
                  outline: '1px solid',
                  outlineColor: '#FFFFFF26',
                },
              }}
            />
          ))}
        </Box>
      )}
      <Typography component="h3">{title}</Typography>
      {description && <Typography>{description}</Typography>}
      {documentData && (
        <SimpleDocumentRenderer document={documentData.document} />
      )}
      {points && (
        <Box
          component="ul"
          sx={{
            listStyleType: 'disc',
            pl: '10px',
            mt: '-2px',
            color: 'grey.500',
          }}
        >
          {points.map((item, index) => (
            <Typography
              key={index}
              component="li"
              variant="body2.400"
              color="grey.500"
              sx={{
                display: 'list-item',
                listStylePosition: 'inside',
                lineHeight: '20px',
              }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      )}
      {imageData && <Image {...imageData} />}
      {actionButtonData && <ActionButton {...actionButtonData} />}
    </Box>
  )
}
